import { FormControlLabel } from '@mui/material';
import React, { forwardRef, PropsWithChildren } from 'react';
import { MuiRadio } from '../mui-radio/index';

type FormControlLabelProps = React.ComponentProps<typeof FormControlLabel>;

/** This creates a radio button with a label. The children will be rendered in the label, all other props end up on {@link FormControlLabel} */
export const FormRadio = forwardRef<HTMLButtonElement, PropsWithChildren<Omit<FormControlLabelProps, 'label' | 'control'>>>(
	({ children, ...labelProps }, ref) => {
		return (
			<FormControlLabel
				label={children}
				componentsProps={{ typography: { variant: 'subtitle2' } }}
				control={<MuiRadio ref={ref} />}
				{...labelProps}
			/>
		);
	}
);
